<template>
    <div class="appointments-container">
        <el-card v-for="(appointment, index) in appointments" :key="index" class="appointment-card" shadow="hover"
            v-if="appointments.length > 0">
            <div class="appointment-content">
                <div class="avatar">
                    <el-avatar :size="50" :src="appointment.patient.avatar">
                        {{ appointment.patient.first_name }}
                    </el-avatar>
                </div>
                <div class="appointment-info">
                    <h4 class="patient-name">{{ appointment.patient.first_name + ' ' + appointment.patient.last_name }}
                    </h4>
                    <p class="appointment-detail">
                        <strong>{{ $t('reception_date') }}</strong> {{ appointment.date }}
                    </p>
                    <p class="appointment-detail">
                        <strong>{{ $t('reception_time') }}</strong> {{ appointment.time }}
                    </p>
                    <p class="appointment-detail">
                        <strong>{{ $t('reception_note') }}</strong> {{ appointment.notes }}
                    </p>
                    <p class="appointment-detail">
                        <strong>{{ $t('reception_status') }}</strong> {{ appointment.status_display }}
                    </p>
                </div>
                <div class="appointment-action">
                    <el-button type="primary" size="small" icon="el-icon-video-camera"
                        @click="startAppointment(appointment)">
                        Начать приём
                    </el-button>
                </div>
            </div>
        </el-card>

        <div class="empty-state" v-if="appointments.length === 0">
            <p class="empty-text">{{ $t('no_receptions') }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UpcomingAppointments',
    data() {
        return {
            appointments: []
        };
    },
    created() {
        this.getData();
    },
    methods: {
        startAppointment(appointment) {
            console.log(`Начинается приём пациента: ${appointment.patientName}`);
        },
        getData() {
            let headers = { Authorization: "Token " + sessionStorage.getItem("key") };
            axios
                .get("appointments/api/", { headers })
                .then((r) => {
                    console.log(r);
                    this.appointments = r.data;
                })
                .catch((e) => {
                    console.log(e);
                });
        },
    }
};
</script>

<style scoped>
.appointments-container {
    padding: 20px;
}

.appointment-card {
    width: 100%;
    margin-bottom: 20px;
    padding: 16px;
    border-radius: 10px;
    box-sizing: border-box;
}

.appointment-content {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    flex-wrap: wrap;
}

.avatar {
    flex-shrink: 0;
}

.appointment-info {
    flex-grow: 1;
    min-width: 200px;
}

.patient-name {
    margin: 0 0 8px;
    font-size: 18px;
    font-weight: 600;
}

.appointment-detail {
    margin: 4px 0;
    font-size: 14px;
    color: #555;
}

.appointment-action {
    margin-left: auto;
    display: flex;
    align-items: flex-end;
}
</style>
